import { Container } from "../../types/Container";
import { TerminalCall } from "../../types/TerminalCall";
import { Vessel } from "../../types/Vessel";

export const  getDepartureStabilityState = (
  vessel: Vessel,
  terminalCall: TerminalCall
) => {
  return !vessel?.linkedVessel && vessel?.barge
    ? terminalCall?.bargedepartureState
    : terminalCall?.departureState;
}

export const getMaxStackHeight = (containers: Container[]): number => {
  const layerStacks: Record<number, Record<string, number>> = {};

  for (const container of containers) {
    const [layer, x, y, vesselId] = container.position;
    const key = `${vesselId}-${x}-${y}`;
    const height = container.containerType?.height ?? 2.89;

    if (!layerStacks[layer]) {
      layerStacks[layer] = {};
    }

    layerStacks[layer][key] = (layerStacks[layer][key] || 0) + height;
  }

  let total = 0;

  for (const layer in layerStacks) {
    const heights = Object.values(layerStacks[layer]);
    if (heights.length > 0) {
      total += Math.max(...heights);
    }
  }

  return total;
};

export const getVesselStackHeight = (vesselBaseOffset: number, draught: number, containers: Container[]): number => {
  const maxStackHeight = getMaxStackHeight(containers);
  const vesselBase = vesselBaseOffset ?? 0.0;
  const vesselDraught = draught / 100;

  return (maxStackHeight - vesselDraught) + vesselBase;
}
